import { Pipe, PipeTransform } from '@angular/core';
import { Constants } from '../models/common/constants';

@Pipe({ name: 'monthPipe' })
export class MonthPipe implements PipeTransform {
  transform(monthId: number, short = false): any {
    if (short === true) {
      return Constants.MONTHS.find(v => v.id === (monthId - 1)).shortKey;  
    }
    return Constants.MONTHS.find(v => v.id === (monthId - 1)).i18nkey;
  }
}
